import cx from 'classnames'
import { MultiStepStepLayout } from 'components/MultiStepFlow/MultiStepStepLayout/MultiStepStepLayout'
import { BrandPlanTacticsContainerProps, BrandPlanTacticsProps, FormValues } from './Types'
import {
  BlogPlatformIntegration,
  EmailPlatformIntegration,
  BrandPlanTactic,
  SelectedBlogPlatform,
  SelectedEmailPlatform,
  BrandPlanStrategyType,
  ContentCount,
  CrosspostFrequency,
  BrandPlan,
  PaidAdsIntegration,
} from 'types'
import { Formik, Form } from 'formik'
import { CrosspostTactics } from 'screens/Campaign/Overview/EditChannelsModal/CrosspostTactics'
import { VideoCrosspostTactics } from 'screens/Campaign/Overview/EditChannelsModal/VideoCrosspostTactics'
import { PaidAdsTactics } from 'screens/Campaign/Overview/EditChannelsModal/PaidAdsTactics'
import CrosspostTacticsStyles from 'screens/Campaign/Overview/EditChannelsModal/CrosspostTactics.module.scss'
import { CheckboxGroup } from 'components/CheckboxGroup/CheckboxGroup'
import { Checkbox as CheckboxComponent } from 'components/CheckboxGroup/Checkbox'
import { TikTokBrand, YouTubeBrand, TwitterBrand, Lock3, Google, MetaBrand } from 'blaze-ui/icons'
import { FacebookBrand as FacebookBrand35 } from 'blaze-ui/icons/35'
import { LinkedInBrand as LinkedInBrand32 } from 'blaze-ui/icons/32'
import { InstagramBrand as InstagramBrand24 } from 'blaze-ui/icons/24'
import { WordPressBrand, GoHighLevelBrand, WixBrand, ShopifyBrand } from 'blaze-ui/icons/35'
import { InstagramReelsBrand } from 'blaze-ui/icons/30'
import { InformationCircleContained, Mailchimp } from 'blaze-ui/icons/20'
import Styles from './BrandPlanTactics.module.scss'
import AutopilotRegistrationAndOnboardingStyles from 'screens/AutopilotRegistration/AutopilotRegistrationAndOnboarding.module.scss'
import { Heading } from 'blaze-ui/Heading/Heading'
import { useBrandPlan } from 'hooks/queries/brandPlans/useBrandPlan'
import { useUpdateBrandPlan } from 'hooks/queries/useUpdateBrandPlan'
import { useMemo, useState, useRef, useEffect } from 'react'
import { FooterButtons, StickyFooter } from 'components/FirstTimeExperienceModal/components/Footer/Footer'
import { Button } from 'blaze-ui/Button'
import VirtualMarketerOnboardingStyles from 'screens/VirtualMarketerOnboarding/VirtualMarketerOnboarding.module.scss'
import { useModals } from 'almanac-ui/Modal'
import { SelectAccountsModal, TACTIC_TO_PROVIDER } from './SelectAccountsModal/SelectAccountsModal'
import { useAddExternalIntegrationsToBrandKit } from 'hooks/queries/useAddExternalIntegrationsToBrandKit'
import { useUpdateBrandProfile } from 'hooks/queries/brandProfiles/useUpdateBrandProfile'
import { Text } from 'blaze-ui/Text/Text'
import { Checkbox, Label as CheckboxLabel, Box as CheckboxBox } from 'blaze-ui/Checkbox/Checkbox'
import { useField, FieldArray } from 'formik'
import { StickyFooterProvider } from 'providers/StickyFooterProvider/StickyFooterProvider'

import { useCreateBrandPlanPreparationSync } from 'hooks/queries/brandPlans/useCreateBrandPlanPreparationSync'
import { useProgress } from 'hooks/useProgress'
import { Loading } from 'screens/VirtualMarketerOnboarding/Loading/Loading'
import { useFlipperFlag } from 'hooks/useFlipperFlag'
import { RadioGroup } from 'components/RadioGroup/RadioGroup'
import { Radio } from 'components/RadioGroup/Radio'
import {
  ExternalIntegration,
  ExternalIntegrationEnum,
  MetaAdsIntegration,
} from 'api/clients/ExternalIntegrationsClient'
import dayjs from 'dayjs'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { ResponsiveDesign } from 'screens/blaze/Home/components/ResponsiveDesign'
import { LinkExternal, PaidAds } from 'blaze-ui/icons'
import { HighDetailedSocial, HighDetailedMail, VideoHighDetail } from 'blaze-ui/icons/40'
import { Blogpost } from 'blaze-ui/icons/24'
import { Tooltip } from 'components/Tooltip/Tooltip'
import XSquareContained from 'blaze-ui/icons/24/XSquareContained'
import { Select } from 'blaze-ui/Select/Select'
import { Item, Section } from '@react-stately/collections'
import { useExternalIntegrations } from 'components/ExportModal/ExternalIntegrations/ExternalIntegrations'
import { ChannelIntegrationButton } from './ChannelIntegrationButton'
import { useHover } from '@react-aria/interactions'
import { useBrandKit } from 'hooks/queries/brandKits/useBrandKit'
import { useDisconnectWithConfirmation } from './hooks/useDisconnectWithConfirmation'
import { Pill } from 'components/Pill/Pill'
import { WeeklyBudgetInput } from './WeeklyBudgetInput/WeeklyBudgetInput'
import { CollectionElement } from '@react-types/shared'

const insightChannelsToTactics: Record<string, BrandPlanTactic> = {
  [ExternalIntegrationEnum.Instagram]: BrandPlanTactic.Instagram,
  [ExternalIntegrationEnum.Facebook]: BrandPlanTactic.Facebook,
  [ExternalIntegrationEnum.LinkedIn]: BrandPlanTactic.LinkedIn,
  [ExternalIntegrationEnum.X]: BrandPlanTactic.Twitter,
  [ExternalIntegrationEnum.TikTok]: BrandPlanTactic.TikTok,
  [ExternalIntegrationEnum.WordPress]: BrandPlanTactic.SEO,
  [ExternalIntegrationEnum.Mailchimp]: BrandPlanTactic.Email,
  [ExternalIntegrationEnum.Shopify]: BrandPlanTactic.SEO,
  [ExternalIntegrationEnum.GoogleBusinessProfile]: BrandPlanTactic.GoogleBusinessProfile,
}

export type SocialTactic = Extract<
  BrandPlanTactic,
  | BrandPlanTactic.Twitter
  | BrandPlanTactic.Facebook
  | BrandPlanTactic.Instagram
  | BrandPlanTactic.InstagramReel
  | BrandPlanTactic.LinkedIn
  | BrandPlanTactic.TikTok
  | BrandPlanTactic.YouTube
  | BrandPlanTactic.GoogleBusinessProfile
>

export const SOCIAL_MEDIA_TACTICS: SocialTactic[] = [
  BrandPlanTactic.Instagram,
  BrandPlanTactic.Facebook,
  BrandPlanTactic.LinkedIn,
  BrandPlanTactic.Twitter,
  BrandPlanTactic.GoogleBusinessProfile,
]

export const VIDEO_TACTICS = [BrandPlanTactic.InstagramReel, BrandPlanTactic.TikTok, BrandPlanTactic.YouTube]

export const SEO_TACTICS = [BrandPlanTactic.SEO]

export const EMAIL_TACTICS = [BrandPlanTactic.Email]

export const STORY_TACTICS = [BrandPlanTactic.Instagram, BrandPlanTactic.Facebook]

export const PAID_ADS_TACTICS = [BrandPlanTactic.MetaAds]

const DEFAULT_SCHEDULE_CONFIG = {
  week_days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
  days_before_review: 3,
  daily_frequency: 'once_a_day',
  length: 6,
  schedule_length: 1,
} as const

const CHECKBOX_PROPS = {
  size: 20 as const,
  color: 'var(--selected-fill)' as const,
}

const PLATFORM_CONFIG = {
  [BrandPlanTactic.Instagram]: {
    contentField: 'instagram_contents' as const,
    defaultType: 'post' as const,
  },
  [BrandPlanTactic.Facebook]: {
    contentField: 'facebook_contents' as const,
    defaultType: 'post' as const,
  },
  [BrandPlanTactic.LinkedIn]: {
    contentField: 'linkedin_contents' as const,
    defaultType: 'post' as const,
  },
  [BrandPlanTactic.Twitter]: {
    contentField: 'twitter_contents' as const,
    defaultType: 'post' as const,
  },
  [BrandPlanTactic.TikTok]: {
    contentField: 'tiktok_contents' as const,
    defaultType: 'post' as const,
  },
  [BrandPlanTactic.YouTube]: {
    contentField: 'youtube_contents' as const,
    defaultType: 'short' as const,
  },
  [BrandPlanTactic.GoogleBusinessProfile]: {
    contentField: 'google_my_business_contents' as const,
    defaultType: 'post' as const,
  },
} as const

const deriveTacticsFromContentArrays = (formValues: Partial<FormValues>): BrandPlanTactic[] => {
  const tactics: BrandPlanTactic[] = []

  Object.entries(PLATFORM_CONFIG).forEach(([tactic, config]) => {
    const contentArray = formValues[config.contentField as keyof FormValues] as ContentCount[] | undefined
    if (contentArray && contentArray.length > 0) {
      tactics.push(tactic as BrandPlanTactic)
    }
  })

  // Special case: InstagramReel (stored in instagram_contents with type 'reel')
  const hasReels = formValues.instagram_contents?.some((c: ContentCount) => c.type === 'reel')
  if (hasReels && !tactics.includes(BrandPlanTactic.InstagramReel)) {
    tactics.push(BrandPlanTactic.InstagramReel)
  }

  return tactics
}

const syncContentArraysWithTactics = (
  tactics: BrandPlanTactic[],
  currentFormValues: Partial<FormValues>,
): Partial<Record<keyof FormValues, ContentCount[]>> => {
  const updates: Partial<Record<keyof FormValues, ContentCount[]>> = {}
  const tacticSet = new Set(tactics)

  // Handle standard platforms
  Object.entries(PLATFORM_CONFIG).forEach(([tactic, config]) => {
    const contentField = config.contentField as keyof FormValues
    const contentArray = currentFormValues[contentField] as ContentCount[] | undefined
    const hasContent = contentArray && contentArray.length > 0
    const tacticSelected = tacticSet.has(tactic as BrandPlanTactic)

    if (tacticSelected && !hasContent) {
      // Tactic selected but no content → add default
      updates[contentField] = [{ type: config.defaultType, count: 0 }] as ContentCount[]
    } else if (!tacticSelected && hasContent) {
      // Tactic not selected but has content → clear
      updates[contentField] = []
    }
  })

  // Special handling for Instagram
  const hasInstagram = tacticSet.has(BrandPlanTactic.Instagram)
  const hasInstagramReel = tacticSet.has(BrandPlanTactic.InstagramReel)

  if (hasInstagram || hasInstagramReel) {
    const desiredContents: ContentCount[] = []
    if (hasInstagram) desiredContents.push({ type: 'post', count: 0 })
    if (hasInstagramReel) desiredContents.push({ type: 'reel', count: 0 })

    const otherTypes =
      currentFormValues.instagram_contents?.filter((c: ContentCount) => c.type !== 'post' && c.type !== 'reel') || []

    const finalContents = [...desiredContents, ...otherTypes]
    if (JSON.stringify(finalContents) !== JSON.stringify(currentFormValues.instagram_contents)) {
      updates.instagram_contents = finalContents
    }
  }

  return updates
}

const ensurePlaceholderContent = (
  fieldName: keyof FormValues,
  hasPlatforms: boolean,
  formValues: FormValues,
  setFieldValue: (field: string, value: ContentCount[]) => void,
) => {
  const currentContent = formValues[fieldName] as ContentCount[] | undefined
  const placeholder: ContentCount[] = [{ type: 'post', count: 0 }]

  if (hasPlatforms) {
    if (!currentContent || currentContent.length === 0) {
      setFieldValue(fieldName, placeholder)
    }
  } else {
    if (!currentContent || currentContent.length !== 1 || currentContent[0]?.count !== 0) {
      setFieldValue(fieldName, placeholder)
    }
  }
}

const updateFieldIfChanged = <T,>(
  fieldName: string,
  newValue: T,
  currentValue: T,
  setFieldValue: (field: string, value: T) => void,
  compareFn: (a: T, b: T) => boolean = (a, b) => JSON.stringify(a) === JSON.stringify(b),
) => {
  if (!compareFn(newValue, currentValue)) {
    setFieldValue(fieldName, newValue)
  }
}

const buildPlatformSelections = (
  isSeoSelected: boolean,
  isEmailSelected: boolean,
  selectedBlogPlatform: SelectedBlogPlatform,
  selectedEmailPlatform: SelectedEmailPlatform,
) => ({
  ...(isSeoSelected ? { selected_blog_platform: selectedBlogPlatform as BlogPlatformIntegration } : {}),
  ...(isEmailSelected ? { selected_email_platform: selectedEmailPlatform as EmailPlatformIntegration } : {}),
})

const SelectItem = ({ icon: Icon, children, size = 20 }: { icon: any; children: React.ReactNode; size?: number }) => (
  <div className={Styles.selectItem}>
    <Icon size={size} />
    <Text color="inherit">{children}</Text>
  </div>
)

// Helper to render platform select dropdown value
const renderPlatformSelectValue = (
  isSelected: boolean,
  selectedPlatform: string | null,
  defaultPlatform: string,
  platformOptions: Record<string, { label: string; icon: any }>,
  noneLabel: string,
  size = 20,
) => {
  const currentKey = isSelected ? selectedPlatform || defaultPlatform : 'none'

  if (platformOptions[currentKey]) {
    const option = platformOptions[currentKey]
    return (
      <SelectItem icon={option.icon} size={size}>
        {option.label}
      </SelectItem>
    )
  }

  if (currentKey === 'generic') {
    return (
      <SelectItem icon={LinkExternal} size={size}>
        I'm using another platform
      </SelectItem>
    )
  }

  if (currentKey === 'none') {
    return (
      <SelectItem icon={XSquareContained} size={size}>
        {noneLabel}
      </SelectItem>
    )
  }

  return null
}

const StoriesTactics = ({ applyRedesign = false }: { applyRedesign?: boolean }) => {
  const integrations = useExternalIntegrations()
  const { isHovered, hoverProps } = useHover({})
  const [field] = useField<Array<{ type: string; count: number }>>('instagram_contents')
  const hasStories = field.value.some((c) => c.type === 'story')

  const matchingIntegrations =
    integrations.data?.external_integrations?.filter(
      (integration: ExternalIntegration) => integration.provider === ExternalIntegrationEnum.Instagram,
    ) || []
  const disconnectWithConfirmation = useDisconnectWithConfirmation(matchingIntegrations)

  const toggleStories = (checked: boolean) => {
    const newContents = checked
      ? [...field.value, { type: 'story', count: 0 }]
      : field.value.filter((c) => c.type !== 'story')
    setValue(newContents)
  }

  // Helper to get/set field value
  const setValue = (newValue: Array<{ type: string; count: number }>) => {
    field.onChange({ target: { name: 'instagram_contents', value: newValue } })
  }

  return (
    <div>
      <CheckboxGroup
        value={hasStories ? ['stories'] : []}
        onChange={(value) => {
          const willHaveStories = value.includes('stories')
          if (!willHaveStories) {
            disconnectWithConfirmation(() => {
              toggleStories(false)
            })
          } else {
            toggleStories(true)
          }
        }}
        className={Styles.storiesGroup}
        aria-label="Stories platform"
      >
        <div className={Styles.storiesCheckbox} {...hoverProps}>
          <CheckboxComponent value="stories" size={20} color="var(--selected-fill)" aria-label="Instagram Stories">
            <div className={Styles.checkboxLabel}>
              {applyRedesign ? <InstagramReelsBrand size={20} /> : <InstagramBrand24 size={24} />}
              <Text variant={applyRedesign ? 'primary' : 'largeList'} color="var(--dark-80)">
                Instagram Stories
              </Text>

              {applyRedesign && (
                <div className={Styles.channelIntegrationButton}>
                  <ChannelIntegrationButton
                    integrations={matchingIntegrations}
                    isHovered={isHovered}
                    provider={ExternalIntegrationEnum.Instagram}
                    isDisabled={!hasStories}
                  />
                </div>
              )}
            </div>
          </CheckboxComponent>
        </div>
      </CheckboxGroup>
    </div>
  )
}

interface ContentTypeCheckboxesProps {
  name: string
  icon: any
  label: string
  availableTypes: Array<{ type: string; label: string }>
}

const ContentTypeCheckboxes = ({ name, icon: Icon, label, availableTypes }: ContentTypeCheckboxesProps) => {
  const [field] = useField<Array<{ type: string; count: number }>>(name)

  return (
    <FieldArray name={name}>
      {({ push, remove }) => {
        const selectedTypes = field.value.map((v) => v.type)

        const toggleType = (type: string, checked: boolean) => {
          if (checked) {
            push({ type, count: 0 })
          } else {
            const index = field.value.findIndex((v) => v.type === type)
            if (index !== -1) {
              remove(index)
            }
          }
        }

        return (
          <section className={Styles.countSection} role="group" aria-label={`${label} content types`}>
            <header className={Styles.header}>
              <Icon size={24} />
              <Text variant="largeList">{label}</Text>
            </header>
            <div className={Styles.content}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', paddingLeft: '30px' }}>
                {availableTypes.map(({ type, label: typeLabel }) => (
                  <Checkbox
                    key={type}
                    {...CHECKBOX_PROPS}
                    isSelected={selectedTypes.includes(type)}
                    onChange={(checked) => toggleType(type, checked)}
                    aria-label={`${typeLabel} for ${label}`}
                  >
                    <span className={Styles.checkboxText}>{typeLabel}</span>
                  </Checkbox>
                ))}
              </div>
            </div>
          </section>
        )
      }}
    </FieldArray>
  )
}

const DEFAULT_CONTENTS = {
  crosspost: [{ type: 'post', count: 0 }],
  video_crosspost: [{ type: 'post', count: 0 }],
  instagram: [
    { type: 'post', count: 0 },
    { type: 'story', count: 0 },
    { type: 'reel', count: 0 },
  ],
  facebook: [{ type: 'post', count: 0 }],
  linkedin: [{ type: 'post', count: 0 }],
  twitter: [{ type: 'post', count: 0 }],
  tiktok: [{ type: 'post', count: 0 }],
  youtube: [{ type: 'short', count: 0 }],
  seo: [{ type: 'blog_post', count: 0 }],
  email: [{ type: 'newsletter', count: 0 }],
  google_my_business: [{ type: 'post', count: 0 }],
}

const getContentOrDefault = (existing: ContentCount[] | undefined, defaultValue: ContentCount[]): ContentCount[] => {
  return defaultValue
}

const getCampaignModeInitialValues = (brandPlan: BrandPlan): FormValues => {
  const crosspostContents = getContentOrDefault(brandPlan.crosspost_contents, DEFAULT_CONTENTS.crosspost)
  const videoCrosspostContents = getContentOrDefault(
    brandPlan.video_crosspost_contents,
    DEFAULT_CONTENTS.video_crosspost,
  )
  const defaultTactics: BrandPlanTactic[] = [...SOCIAL_MEDIA_TACTICS, ...VIDEO_TACTICS, ...PAID_ADS_TACTICS]

  const contentValues = {
    crosspost_frequency: (brandPlan.crosspost_frequency || 'always') as CrosspostFrequency,
    crosspost_contents: crosspostContents,
    video_crosspost_contents: videoCrosspostContents,
    instagram_contents: getContentOrDefault(brandPlan.instagram_contents, DEFAULT_CONTENTS.instagram),
    facebook_contents: getContentOrDefault(brandPlan.facebook_contents, DEFAULT_CONTENTS.facebook),
    linkedin_contents: getContentOrDefault(brandPlan.linkedin_contents, DEFAULT_CONTENTS.linkedin),
    twitter_contents: getContentOrDefault(brandPlan.twitter_contents, DEFAULT_CONTENTS.twitter),
    tiktok_contents: getContentOrDefault(brandPlan.tiktok_contents, DEFAULT_CONTENTS.tiktok),
    youtube_contents: getContentOrDefault(brandPlan.youtube_contents, DEFAULT_CONTENTS.youtube),
    seo_contents: getContentOrDefault(brandPlan.seo_contents, DEFAULT_CONTENTS.seo),
    email_contents: getContentOrDefault(brandPlan.email_contents, DEFAULT_CONTENTS.email),
    google_my_business_contents: getContentOrDefault(
      brandPlan.google_my_business_contents,
      DEFAULT_CONTENTS.google_my_business,
    ),
    week_days: [...DEFAULT_SCHEDULE_CONFIG.week_days] as string[],
  }

  const derivedTactics = deriveTacticsFromContentArrays(contentValues)
  const finalSocialTactics = derivedTactics.length > 0 ? derivedTactics : defaultTactics
  const finalTactics = [...finalSocialTactics, ...PAID_ADS_TACTICS]

  return {
    ...contentValues,
    tactics: finalTactics,
    weekly_ads_budget: 0,
  }
}

interface PlatformSelectProps {
  type: 'blog' | 'email'
  isSelected: boolean
  selectedPlatform: string
  onSelectionChange: (isSelected: boolean) => void
  onPlatformChange: (platform: string) => void
  wixEnabled?: boolean
  shopifyEnabled?: boolean
  showOnlyDropdown?: boolean
  size?: 'sm' | 'md' | 'lg'
  isDisabled?: boolean
  allowNone?: boolean
}

const PLATFORM_CONFIGS = {
  blog: {
    icon: Blogpost,
    title: 'Blog',
    subtitle: 'Own search results',
    mobileTitle: 'Select a blog platform',
    defaultPlatform: ExternalIntegrationEnum.WordPress,
    platforms: (wixEnabled: boolean = false, shopifyEnabled: boolean = false) => [
      { value: ExternalIntegrationEnum.WordPress, label: 'WordPress', icon: WordPressBrand },
      { value: ExternalIntegrationEnum.GoHighLevel, label: 'GoHighLevel', icon: GoHighLevelBrand },
      ...(wixEnabled ? [{ value: ExternalIntegrationEnum.Wix, label: 'Wix', icon: WixBrand }] : []),
      ...(shopifyEnabled ? [{ value: ExternalIntegrationEnum.Shopify, label: 'Shopify', icon: ShopifyBrand }] : []),
      { value: 'generic', label: "I'm using another platform", icon: null },
    ],
    sectionClass: 'blogPlatformSection',
  },
  email: {
    icon: HighDetailedMail,
    title: 'Email',
    subtitle: 'Stay top-of-mind',
    mobileTitle: 'Select an email provider',
    defaultPlatform: ExternalIntegrationEnum.Mailchimp,
    platforms: () => [
      { value: ExternalIntegrationEnum.Mailchimp, label: 'Mailchimp', icon: Mailchimp },
      { value: 'generic', label: "I'm using another platform", icon: null },
    ],
    sectionClass: 'emailPlatformSection',
  },
} as const

const PlatformSelect = ({
  type,
  isSelected,
  selectedPlatform,
  onSelectionChange,
  onPlatformChange,
  wixEnabled,
  shopifyEnabled,
  showOnlyDropdown = false,
  size = 'lg',
  isDisabled = false,
  allowNone = true,
}: PlatformSelectProps) => {
  const integrations = useExternalIntegrations()
  const { isHovered, hoverProps } = useHover({})
  const { isMobile } = useResponsiveDesign()
  const config = PLATFORM_CONFIGS[type]
  const platforms = config.platforms(wixEnabled || false, shopifyEnabled || false)
  const matchingIntegrations =
    integrations.data?.external_integrations?.filter(
      (integration: ExternalIntegration) => integration.provider === selectedPlatform,
    ) || []
  const disconnectWithConfirmation = useDisconnectWithConfirmation(matchingIntegrations)

  const handlePlatformChange = (isSelected: boolean) => {
    if (!isSelected) {
      disconnectWithConfirmation(() => {
        onSelectionChange(isSelected)
      })
    } else {
      onSelectionChange(isSelected)
    }
  }

  const iconSize = size === 'md' ? 15 : 20

  const dropdown = (
    <Select
      selectedKey={isSelected ? selectedPlatform || config.defaultPlatform : 'none'}
      onSelectionChange={(key) => {
        const value = String(key)
        if (value === 'none') {
          handlePlatformChange(false)
        } else {
          handlePlatformChange(true)
          onPlatformChange(value)
        }
      }}
      isDisabled={isDisabled}
      variant="secondary"
      size={size}
      aria-label={`${config.title} platform selection`}
      renderSelectValue={(selectedItem) => {
        if (!selectedItem) return null
        return renderPlatformSelectValue(
          isSelected,
          selectedPlatform,
          config.defaultPlatform,
          Object.fromEntries(platforms.filter((p) => p.icon).map((p) => [p.value, { label: p.label, icon: p.icon }])),
          `I don't want ${type === 'blog' ? 'blog posts' : 'emails'}`,
          iconSize,
        )
      }}
    >
      {
        [
          <Section key="platforms">
            {platforms.map(({ value, label, icon: PlatformIcon }) => (
              <Item key={value} textValue={label}>
                {PlatformIcon ? (
                  <SelectItem icon={PlatformIcon} size={iconSize}>
                    {label}
                  </SelectItem>
                ) : (
                  <div className={Styles.selectItemWrapper}>
                    <SelectItem icon={LinkExternal} size={iconSize}>
                      {label}
                    </SelectItem>
                    <div className={Styles.selectItemSubtext}>
                      <span className={Styles.selectItemSubtextContent}>
                        We'll still create {type === 'blog' ? 'blog posts' : 'emails'} for you, but you'll need to{' '}
                        {type === 'blog' ? 'publish' : 'send'} them yourself.
                      </span>
                    </div>
                  </div>
                )}
              </Item>
            ))}
          </Section>,
          allowNone && (
            <Section key="none">
              <Item key="none" textValue={`I don't want ${type === 'blog' ? 'blog posts' : 'emails'}`}>
                <SelectItem icon={XSquareContained} size={iconSize}>
                  I don't want {type === 'blog' ? 'blog posts' : 'emails'}
                </SelectItem>
              </Item>
            </Section>
          ),
        ].filter(Boolean) as CollectionElement<object>[]
      }
    </Select>
  )

  return (
    <section className={cx(Styles.section, { [Styles.showOnlyDropdown]: showOnlyDropdown })}>
      {!showOnlyDropdown && (
        <header className={Styles.sectionHeader}>
          <div className={Styles.sectionHeading}>
            <Heading level={3}>{config.title}</Heading>
          </div>
        </header>
      )}
      {!isMobile && (
        <div
          className={cx(Styles.platformCheckboxSection, Styles[size])}
          onClick={() => handlePlatformChange(!isSelected)}
          {...hoverProps}
        >
          {!showOnlyDropdown && <Checkbox {...CHECKBOX_PROPS} isSelected={isSelected} aria-label={`Enable ${type}`} />}
          {dropdown}

          {!showOnlyDropdown && selectedPlatform !== 'generic' && (
            <div className={Styles.channelIntegrationButton}>
              <ChannelIntegrationButton
                integrations={matchingIntegrations}
                isHovered={isHovered}
                provider={selectedPlatform as ExternalIntegrationEnum}
                isDisabled={!isSelected}
              />
            </div>
          )}
        </div>
      )}
      {isMobile && (
        <div className={Styles.platformCheckboxSection}>
          {!showOnlyDropdown && (
            <Checkbox
              {...CHECKBOX_PROPS}
              isSelected={isSelected}
              onChange={handlePlatformChange}
              aria-label={`Enable ${type}`}
            />
          )}
          {dropdown}
        </div>
      )}
    </section>
  )
}

interface BlogPlatformSelectProps {
  isSelected: boolean
  selectedPlatform: SelectedBlogPlatform
  onSelectionChange: (isSelected: boolean) => void
  onPlatformChange: (platform: SelectedBlogPlatform) => void
  wixEnabled: boolean
  shopifyEnabled: boolean
  showOnlyDropdown?: boolean
  size?: 'sm' | 'md' | 'lg'
  isDisabled?: boolean
  allowNone?: boolean
}

export const BlogPlatformSelect = ({
  selectedPlatform,
  onPlatformChange,
  wixEnabled,
  shopifyEnabled,
  showOnlyDropdown = false,
  size = 'lg',
  allowNone = true,
  ...rest
}: BlogPlatformSelectProps) => (
  <PlatformSelect
    type="blog"
    selectedPlatform={selectedPlatform || ExternalIntegrationEnum.WordPress}
    onPlatformChange={(platform) => onPlatformChange(platform as SelectedBlogPlatform)}
    wixEnabled={wixEnabled}
    shopifyEnabled={shopifyEnabled}
    showOnlyDropdown={showOnlyDropdown}
    size={size}
    allowNone={allowNone}
    {...rest}
  />
)

interface EmailPlatformSelectProps {
  isSelected: boolean
  selectedPlatform: SelectedEmailPlatform
  onSelectionChange: (isSelected: boolean) => void
  onPlatformChange: (platform: SelectedEmailPlatform) => void
  showOnlyDropdown?: boolean
  size?: 'sm' | 'md' | 'lg'
  isDisabled?: boolean
  allowNone?: boolean
}

export const EmailPlatformSelect = ({
  selectedPlatform,
  onPlatformChange,
  showOnlyDropdown = false,
  size = 'lg',
  allowNone = true,
  ...rest
}: EmailPlatformSelectProps) => (
  <PlatformSelect
    type="email"
    selectedPlatform={selectedPlatform || ExternalIntegrationEnum.Mailchimp}
    onPlatformChange={(platform) => onPlatformChange(platform as SelectedEmailPlatform)}
    showOnlyDropdown={showOnlyDropdown}
    size={size}
    allowNone={allowNone}
    {...rest}
  />
)

interface EvergreenPlatformSectionProps {
  type: 'blog' | 'email'
  isSelected: boolean
  selectedPlatform: string | null
  onSelectionChange: (isSelected: boolean) => void
  onPlatformChange: (platform: string) => void
  wixEnabled?: boolean
  isDisabled?: boolean
  disabledTooltip?: string
  shopifyEnabled?: boolean
}

const EvergreenPlatformSection = ({
  type,
  isSelected,
  selectedPlatform,
  onSelectionChange,
  onPlatformChange,
  wixEnabled = false,
  shopifyEnabled = false,
  isDisabled,
  disabledTooltip,
}: EvergreenPlatformSectionProps) => {
  const { isMobile } = useResponsiveDesign()
  const config = PLATFORM_CONFIGS[type]
  const platforms = config.platforms(wixEnabled, shopifyEnabled)
  const isSectionDisabled = isDisabled && !isSelected
  const integrations = useExternalIntegrations()
  const matchingIntegrations =
    integrations.data?.external_integrations?.filter(
      (integration: ExternalIntegration) => integration.provider === (selectedPlatform as ExternalIntegrationEnum),
    ) || []
  const { isHovered, hoverProps } = useHover({})
  const disconnectWithConfirmation = useDisconnectWithConfirmation(matchingIntegrations)

  const handlePlatformChange = (isSelected: boolean) => {
    if (!isSelected) {
      disconnectWithConfirmation(() => {
        onSelectionChange(isSelected)
      })
    } else {
      onSelectionChange(isSelected)
    }
  }

  const content = (
    <section className={cx(Styles.evergreenSection, { [Styles.sectionDisabled]: isSectionDisabled })}>
      <div className={Styles.sectionContent}>
        <header className={Styles.evergreenSectionHeader}>
          <div className={Styles.sectionHeading}>
            <Heading level={3}>{config.title}</Heading>
          </div>
        </header>
        {!isMobile && (
          <div className={Styles.evergreenDropdown} {...hoverProps}>
            <CheckboxLabel
              className={Styles.platformCheckbox}
              isSelected={isSelected}
              onChange={handlePlatformChange}
              aria-label={config.title}
              isDisabled={isSectionDisabled}
            >
              <CheckboxBox size={20} color="var(--dark-80)" />
              {isSectionDisabled && (
                <div className={Styles.lockIcon}>
                  <Lock3 size={12} color="var(--dark-40)" />
                </div>
              )}
              <Select
                selectedKey={selectedPlatform || config.defaultPlatform}
                onSelectionChange={(key) => {
                  disconnectWithConfirmation(() => {
                    onPlatformChange(String(key))
                  })
                }}
                variant="secondary"
                size="lg"
                aria-label={`${config.title} platform selection`}
                isDisabled={false}
                renderSelectValue={(selectedItem) => {
                  if (!selectedItem) return null
                  const platform = platforms.find((p) => p.value === (selectedPlatform || config.defaultPlatform))
                  if (platform?.icon) {
                    const PlatformIcon = platform.icon
                    return <SelectItem icon={PlatformIcon}>{platform.label}</SelectItem>
                  }
                  return <SelectItem icon={LinkExternal}>I'm using another platform</SelectItem>
                }}
              >
                <Section>
                  {platforms.map(({ value, label, icon: PlatformIcon }) => (
                    <Item key={value} textValue={label}>
                      {PlatformIcon ? (
                        <SelectItem icon={PlatformIcon}>{label}</SelectItem>
                      ) : (
                        <div className={Styles.selectItemWrapper}>
                          <SelectItem icon={LinkExternal}>{label}</SelectItem>
                          <div className={Styles.selectItemSubtext}>
                            <span className={Styles.selectItemSubtextContent}>
                              We'll still create {type === 'blog' ? 'blog posts' : 'emails'} for you, but you'll need to{' '}
                              {type === 'blog' ? 'publish' : 'send'} them yourself.
                            </span>
                          </div>
                        </div>
                      )}
                    </Item>
                  ))}
                </Section>
              </Select>
              {selectedPlatform !== 'generic' && (
                <div className={Styles.channelIntegrationButton}>
                  <ChannelIntegrationButton
                    integrations={matchingIntegrations}
                    isHovered={isHovered}
                    provider={selectedPlatform as ExternalIntegrationEnum}
                    isDisabled={!isSelected}
                    showDisabledLabel={isSectionDisabled}
                  />
                </div>
              )}
            </CheckboxLabel>
          </div>
        )}
      </div>
      {isMobile && isSelected && (
        <div className={Styles[config.sectionClass]}>
          <Heading level={4}>{config.mobileTitle}</Heading>
          <RadioGroup
            value={selectedPlatform || config.defaultPlatform}
            onChange={(value: string | null) => value && onPlatformChange(value)}
            aria-label={`${config.title} platform selection`}
          >
            {platforms.map(({ value, label, icon: PlatformIcon }) => (
              <Radio key={value} value={value}>
                <div className={Styles.platformOption}>
                  {PlatformIcon && <PlatformIcon size={24} />}
                  <Text variant="largeList" color="var(--dark-80)">
                    {label}
                  </Text>
                </div>
              </Radio>
            ))}
          </RadioGroup>
        </div>
      )}
    </section>
  )

  return content
}

interface ChannelCheckboxProps {
  icon: React.ComponentType<{ size?: number }>
  label: string
  isSelected: boolean
  onChange: (isSelected: boolean) => void
  isDisabled?: boolean
  disabledTooltip?: string
  provider?: ExternalIntegrationEnum
  noProviderRequired?: boolean
  tooltip?: string
}

const ChannelCheckbox = ({
  icon: Icon,
  label,
  isSelected,
  onChange,
  isDisabled,
  disabledTooltip,
  provider,
  noProviderRequired,
  tooltip,
}: ChannelCheckboxProps) => {
  const { isHovered, hoverProps } = useHover({})
  const integrations = useExternalIntegrations()
  const isItemDisabled = isDisabled && !isSelected
  const matchingIntegrations =
    integrations.data?.external_integrations?.filter(
      (integration: ExternalIntegration) => integration.provider === provider,
    ) || []
  const disconnectWithConfirmation = useDisconnectWithConfirmation(matchingIntegrations)

  const content = (
    <div className={cx(Styles.channelCheckbox)} {...hoverProps}>
      <Checkbox
        {...CHECKBOX_PROPS}
        isSelected={isSelected}
        onChange={(isSelected) => {
          if (!isSelected) {
            disconnectWithConfirmation(() => {
              onChange(isSelected)
            })
          } else {
            onChange(isSelected)
          }
        }}
        aria-label={label}
        isDisabled={isItemDisabled}
      >
        <div className={Styles.channelCheckboxContent}>
          {isItemDisabled && (
            <div className={Styles.lockIcon}>
              <Lock3 size={12} color="var(--dark-40)" />
            </div>
          )}
          <div className={Styles.channelLabel}>
            <Icon size={20} />
            <span>{label}</span>
            {provider === undefined && !noProviderRequired ? (
              <Pill className={Styles.comingSoonPill} size="sm">
                Coming Soon
              </Pill>
            ) : null}
            {tooltip && (
              <Tooltip label={tooltip} placement="bottom">
                <div style={{ display: 'flex', alignItems: 'center', marginLeft: -5 }}>
                  <InformationCircleContained size={16} color="var(--dark-15)" />
                </div>
              </Tooltip>
            )}
          </div>

          {!noProviderRequired && (
            <ChannelIntegrationButton
              integrations={matchingIntegrations}
              isHovered={isHovered}
              provider={provider}
              isDisabled={isItemDisabled}
              showDisabledLabel={isItemDisabled}
            />
          )}
        </div>
      </Checkbox>
    </div>
  )

  return content
}

interface ChannelConfig {
  tactic: BrandPlanTactic
  label: string
  icon: React.ComponentType<{ size?: number }>
  noProviderRequired?: boolean
  tooltip?: string
}

interface EvergreenChannelSectionProps {
  icon: React.ComponentType<{ size?: number }>
  title: string
  subtitle: string
  channels: ChannelConfig[]
  selectedTactics: BrandPlanTactic[]
  onTacticsChange: (tactics: BrandPlanTactic[], isSelected: boolean) => void
  isAtChannelLimit: boolean
  disabledTooltip: string
  rightContent?: React.ReactNode
}

const EvergreenChannelSection = ({
  icon: SectionIcon,
  title,
  subtitle,
  channels,
  selectedTactics,
  onTacticsChange,
  isAtChannelLimit,
  disabledTooltip,
  rightContent,
}: EvergreenChannelSectionProps) => {
  return (
    <section className={Styles.evergreenSection}>
      <div className={Styles.sectionContent}>
        <header className={Styles.evergreenSectionHeader}>
          <div className={Styles.sectionHeading}>
            <Heading level={3}>{title}</Heading>
            {rightContent}
          </div>
        </header>
      </div>
      <div className={Styles.evergreenChannels}>
        {channels.map(({ tactic, label, icon, noProviderRequired, tooltip }) => {
          const provider = TACTIC_TO_PROVIDER[tactic]
          const isDisabled = (!provider && !noProviderRequired) || isAtChannelLimit
          const disabledTooltipText = provider || noProviderRequired ? disabledTooltip : 'Coming Soon'

          return (
            <ChannelCheckbox
              key={tactic}
              icon={icon}
              label={label}
              isSelected={selectedTactics.includes(tactic)}
              onChange={(isSelected) => onTacticsChange([tactic], isSelected)}
              isDisabled={isDisabled}
              disabledTooltip={disabledTooltipText}
              provider={provider}
              noProviderRequired={noProviderRequired}
              tooltip={tooltip}
            />
          )
        })}
      </div>
    </section>
  )
}

interface CampaignModeFormProps {
  onSubmit: (values: FormValues) => void
  isLoading: boolean
  brandPlan: BrandPlan
  isSeoSelected: boolean
  isEmailSelected: boolean
  selectedBlogPlatform: SelectedBlogPlatform
  selectedEmailPlatform: SelectedEmailPlatform
  onSeoSelectionChange: (isSelected: boolean) => void
  onEmailSelectionChange: (isSelected: boolean) => void
  onBlogPlatformChange: (platform: SelectedBlogPlatform) => void
  onEmailPlatformChange: (platform: SelectedEmailPlatform) => void
  wixEnabled: boolean
  startDate: string
  onStartDateChange: (date: string) => void
  shopifyEnabled: boolean
  googleMyBusinessEnabled: boolean
}

const CampaignModePaidAdsSection = ({ hideComingSoon = false }: { hideComingSoon?: boolean }) => {
  const [field, , helpers] = useField<number | undefined>('weekly_ads_budget')
  const [tacticsField] = useField<BrandPlanTactic[]>('tactics')
  const noSelectedAdChannels = useMemo(
    () => !PAID_ADS_TACTICS.some((tactic) => tacticsField.value.includes(tactic)),
    [tacticsField.value],
  )

  return (
    <section className={cx(Styles.section, Styles.socialMediaSection)}>
      <header className={Styles.sectionHeader}>
        <div className={Styles.sectionHeading}>
          <Heading level={3}>Paid Ads</Heading>
          <WeeklyBudgetInput
            value={field.value}
            onChange={(value) => helpers.setValue(value)}
            disabled={noSelectedAdChannels}
          />
        </div>
      </header>
      <div className={Styles.channels}>
        <div className={Styles.platformSelection}>
          <PaidAdsTactics
            className={CrosspostTacticsStyles.mobileFullWidth}
            applyRedesign
            hideComingSoon={hideComingSoon}
          />
        </div>
      </div>
    </section>
  )
}

interface CampaignModeFormContentProps {
  formValues: FormValues
  setFieldValue: (field: string, value: any) => void
  isValid: boolean
  isLoading: boolean
  isSeoSelected: boolean
  isEmailSelected: boolean
  selectedBlogPlatform: SelectedBlogPlatform
  selectedEmailPlatform: SelectedEmailPlatform
  onSeoSelectionChange: (isSelected: boolean) => void
  onEmailSelectionChange: (isSelected: boolean) => void
  onBlogPlatformChange: (platform: SelectedBlogPlatform) => void
  onEmailPlatformChange: (platform: SelectedEmailPlatform) => void
  wixEnabled: boolean
  startDate: string
  onStartDateChange: (date: string) => void
  shopifyEnabled: boolean
  adsIntegration?: MetaAdsIntegration
  googleMyBusinessEnabled: boolean
}

const CampaignModeFormContent = ({
  formValues,
  setFieldValue,
  isValid,
  isLoading,
  isSeoSelected,
  isEmailSelected,
  selectedBlogPlatform,
  selectedEmailPlatform,
  onSeoSelectionChange,
  onEmailSelectionChange,
  onBlogPlatformChange,
  onEmailPlatformChange,
  wixEnabled,
  shopifyEnabled,
  startDate,
  onStartDateChange,
  adsIntegration,
  googleMyBusinessEnabled,
}: CampaignModeFormContentProps) => {
  const { isMobile } = useResponsiveDesign()
  const isAdsOnboardingEnabled = useFlipperFlag('ads_onboarding')
  const prevCrosspostMode = useRef(formValues.crosspost_frequency)

  useEffect(() => {
    const crosspostMode = formValues.crosspost_frequency
    const modeChanged = prevCrosspostMode.current !== crosspostMode

    if (modeChanged) {
      prevCrosspostMode.current = crosspostMode

      if (crosspostMode === 'always') {
        const derivedTactics = deriveTacticsFromContentArrays(formValues)
        updateFieldIfChanged('tactics', derivedTactics.sort(), formValues.tactics.sort(), setFieldValue)
      } else if (crosspostMode === 'never') {
        const updates = syncContentArraysWithTactics(formValues.tactics, formValues)
        Object.entries(updates).forEach(([key, value]) => {
          setFieldValue(key, value)
        })
      }
      return
    }

    if (crosspostMode === 'always') {
      const socialPlatforms = formValues.tactics.filter((t: BrandPlanTactic) =>
        SOCIAL_MEDIA_TACTICS.includes(t as SocialTactic),
      )
      const videoPlatforms = formValues.tactics.filter((t: BrandPlanTactic) => VIDEO_TACTICS.includes(t))
      ensurePlaceholderContent('crosspost_contents', socialPlatforms.length > 0, formValues, setFieldValue)
      ensurePlaceholderContent('video_crosspost_contents', videoPlatforms.length > 0, formValues, setFieldValue)
    }

    if (crosspostMode === 'never') {
      const derivedTactics = deriveTacticsFromContentArrays(formValues)
      updateFieldIfChanged('tactics', derivedTactics.sort(), formValues.tactics.sort(), setFieldValue)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    formValues.crosspost_frequency,
    formValues.tactics,
    formValues.instagram_contents,
    formValues.facebook_contents,
    formValues.linkedin_contents,
    formValues.twitter_contents,
    formValues.tiktok_contents,
    formValues.youtube_contents,
    formValues.crosspost_contents,
    formValues.video_crosspost_contents,
    formValues.google_my_business_contents,
    setFieldValue,
  ])

  const hasSocialMedia =
    formValues.tactics.some((t: BrandPlanTactic) => SOCIAL_MEDIA_TACTICS.includes(t as SocialTactic)) ||
    formValues.tactics.some((t: BrandPlanTactic) => VIDEO_TACTICS.includes(t))

  const handleSocialMediaToggle = (isSelected: boolean) => {
    if (!isSelected) {
      const newTactics = formValues.tactics.filter(
        (t: BrandPlanTactic) => !SOCIAL_MEDIA_TACTICS.includes(t as SocialTactic) && !VIDEO_TACTICS.includes(t),
      )
      setFieldValue('tactics', newTactics)
      setFieldValue('crosspost_contents', [{ type: 'post', count: 0 }])
      setFieldValue('video_crosspost_contents', [{ type: 'post', count: 0 }])
      setFieldValue('instagram_contents', [])
      setFieldValue('facebook_contents', [])
      setFieldValue('linkedin_contents', [])
      setFieldValue('twitter_contents', [])
      setFieldValue('tiktok_contents', [])
      setFieldValue('youtube_contents', [])
      setFieldValue('google_my_business_contents', [])
    } else {
      const defaultTactics = [...SOCIAL_MEDIA_TACTICS, ...VIDEO_TACTICS]
      const newTactics = Array.from(new Set([...formValues.tactics, ...defaultTactics]))
      setFieldValue('tactics', newTactics)

      if (formValues.crosspost_frequency === 'always') {
        setFieldValue('crosspost_contents', [{ type: 'post', count: 0 }])
        setFieldValue('video_crosspost_contents', [{ type: 'post', count: 0 }])
        setFieldValue('instagram_contents', [
          { type: 'post', count: 0 },
          { type: 'story', count: 0 },
          { type: 'reel', count: 0 },
        ])
      } else {
        setFieldValue('instagram_contents', [
          { type: 'post', count: 0 },
          { type: 'story', count: 0 },
          { type: 'reel', count: 0 },
        ])
        setFieldValue('facebook_contents', [{ type: 'post', count: 0 }])
        setFieldValue('linkedin_contents', [{ type: 'post', count: 0 }])
        setFieldValue('twitter_contents', [{ type: 'post', count: 0 }])
        setFieldValue('tiktok_contents', [{ type: 'post', count: 0 }])
        setFieldValue('youtube_contents', [{ type: 'short', count: 0 }])
      }
    }
  }

  return (
    <Form>
      <div className={Styles.brandPlanTactics}>
        <section className={cx(Styles.section, Styles.socialMediaSection)}>
          <header className={Styles.sectionHeader}>
            {!isMobile && (
              <ResponsiveDesign.Mobile>
                <Checkbox
                  {...CHECKBOX_PROPS}
                  isSelected={hasSocialMedia}
                  onChange={handleSocialMediaToggle}
                  aria-label="Social Media enabled"
                />
              </ResponsiveDesign.Mobile>
            )}
            <div className={Styles.sectionHeading}>
              <Heading level={3}>Social Media</Heading>
            </div>
          </header>
          {formValues.crosspost_frequency === 'never' && (
            <div className={Styles.channels}>
              <Heading level={4}>Which channels do you want to post to?</Heading>
              <div className={Styles.socialChannels}>
                <ContentTypeCheckboxes
                  icon={InstagramBrand24}
                  label="Instagram"
                  name="instagram_contents"
                  availableTypes={[
                    { type: 'post', label: 'Posts' },
                    { type: 'story', label: 'Stories' },
                    { type: 'reel', label: 'Reels' },
                  ]}
                />
                <ContentTypeCheckboxes
                  icon={FacebookBrand35}
                  label="Facebook"
                  name="facebook_contents"
                  availableTypes={[{ type: 'post', label: 'Posts' }]}
                />
                <ContentTypeCheckboxes
                  icon={LinkedInBrand32}
                  label="LinkedIn"
                  name="linkedin_contents"
                  availableTypes={[{ type: 'post', label: 'Posts' }]}
                />
                <ContentTypeCheckboxes
                  icon={YouTubeBrand}
                  label="YouTube"
                  name="youtube_contents"
                  availableTypes={[{ type: 'short', label: 'Shorts' }]}
                />
                <ContentTypeCheckboxes
                  icon={TwitterBrand}
                  label="X / Twitter"
                  name="twitter_contents"
                  availableTypes={[{ type: 'post', label: 'Posts' }]}
                />
                <ContentTypeCheckboxes
                  icon={TikTokBrand}
                  label="TikTok"
                  name="tiktok_contents"
                  availableTypes={[{ type: 'post', label: 'Videos' }]}
                />
                {googleMyBusinessEnabled && (
                  <ContentTypeCheckboxes
                    icon={Google}
                    label="Business Profile"
                    name="google_my_business_contents"
                    availableTypes={[{ type: 'post', label: 'Updates' }]}
                  />
                )}
              </div>
            </div>
          )}
          {formValues.crosspost_frequency === 'always' && (
            <div className={Styles.channels}>
              <div className={Styles.platformSelection}>
                <CrosspostTactics className={CrosspostTacticsStyles.mobileFullWidth} applyRedesign={true} />
              </div>
            </div>
          )}
        </section>
        <section className={cx(Styles.section, Styles.socialMediaSection)}>
          <header className={Styles.sectionHeader}>
            <div className={Styles.sectionHeading}>
              <Heading level={3}>{isMobile ? 'Short-form Video' : 'Video Content'}</Heading>
            </div>
          </header>
          <div className={Styles.channels}>
            <div className={cx(Styles.platformSelection, Styles.videoContentSelection)}>
              <StoriesTactics applyRedesign={true} />
              <VideoCrosspostTactics className={CrosspostTacticsStyles.mobileFullWidth} applyRedesign={true} />
            </div>
          </div>
        </section>

        {isAdsOnboardingEnabled && <CampaignModePaidAdsSection hideComingSoon={isMobile} />}

        <BlogPlatformSelect
          isSelected={isSeoSelected}
          selectedPlatform={selectedBlogPlatform}
          onSelectionChange={onSeoSelectionChange}
          onPlatformChange={onBlogPlatformChange}
          wixEnabled={wixEnabled}
          shopifyEnabled={shopifyEnabled}
        />

        <EmailPlatformSelect
          isSelected={isEmailSelected}
          selectedPlatform={selectedEmailPlatform}
          onSelectionChange={onEmailSelectionChange}
          onPlatformChange={onEmailPlatformChange}
        />
      </div>
      {/* Hidden button triggered by parent component */}
      <button
        type="submit"
        style={{ display: 'none' }}
        disabled={!isValid || isLoading}
        id="campaign-mode-submit-button"
      />
    </Form>
  )
}

const CampaignModeForm = ({
  onSubmit,
  isLoading,
  brandPlan,
  isSeoSelected,
  isEmailSelected,
  selectedBlogPlatform,
  selectedEmailPlatform,
  onSeoSelectionChange,
  onEmailSelectionChange,
  onBlogPlatformChange,
  onEmailPlatformChange,
  wixEnabled,
  startDate,
  onStartDateChange,
  shopifyEnabled,
  googleMyBusinessEnabled,
}: CampaignModeFormProps) => {
  const initialValues = getCampaignModeInitialValues(brandPlan)

  return (
    <Formik validateOnMount={false} initialValues={initialValues} onSubmit={onSubmit}>
      {({ values: formValues, isValid, setFieldValue }) => (
        <CampaignModeFormContent
          formValues={formValues}
          setFieldValue={setFieldValue}
          isValid={isValid}
          isLoading={isLoading}
          isSeoSelected={isSeoSelected}
          isEmailSelected={isEmailSelected}
          selectedBlogPlatform={selectedBlogPlatform}
          selectedEmailPlatform={selectedEmailPlatform}
          onSeoSelectionChange={onSeoSelectionChange}
          onEmailSelectionChange={onEmailSelectionChange}
          onBlogPlatformChange={onBlogPlatformChange}
          onEmailPlatformChange={onEmailPlatformChange}
          wixEnabled={wixEnabled}
          startDate={startDate}
          onStartDateChange={onStartDateChange}
          shopifyEnabled={shopifyEnabled}
          googleMyBusinessEnabled={googleMyBusinessEnabled}
        />
      )}
    </Formik>
  )
}

const STARTER_PLAN_CHANNEL_LIMIT = 3
const STARTER_PLAN_DISABLED_TOOLTIP = 'To enable this channel, remove another first'

const BrandPlanTactics = ({
  brandPlan,
  onBack,
  onNext,
  externalIntegrations,
  brandKitId,
  tactics: initialTactics,
  seoKeywords: initialSeoKeywords,
  idealCustomers: initialIdealCustomers,
  mode = 'evergreen',
  skipBrandPlanUpdate = false,
  initialInsightChannels = [],
  onProvideBackHandler,
}: BrandPlanTacticsProps) => {
  const isCampaignMode = mode === 'campaign'
  const isStarterPlan = mode === 'starter'
  const isEvergreenMode = mode === 'evergreen' || mode === 'starter'
  const [startDate, setStartDate] = useState(dayjs().add(1, 'day').format('YYYY-MM-DD'))
  const [isSubmitButtonDisabled, setIsSubmitButtonDisabled] = useState(false)
  const abortControllerRef = useRef<AbortController | null>(null)
  const wixEnabled = useFlipperFlag('wix_blog_integration')
  const shopifyEnabled = useFlipperFlag('shopify_integration')
  const isAdsOnboardingEnabled = useFlipperFlag('ads_onboarding')
  const googleMyBusinessEnabled = useFlipperFlag('google_business_profile_integration')
  const brand_kit = useBrandKit(brandKitId).data?.brand_kit
  const [selectedBlogPlatform, setSelectedBlogPlatform] = useState<SelectedBlogPlatform>(
    ExternalIntegrationEnum.WordPress,
  )
  const [selectedEmailPlatform, setSelectedEmailPlatform] = useState<SelectedEmailPlatform>(
    ExternalIntegrationEnum.Mailchimp,
  )
  const [weeklyAdsBudget, setWeeklyAdsBudget] = useState<number | undefined>(undefined)
  const { isMobile } = useResponsiveDesign()

  useEffect(() => {
    if (onProvideBackHandler && isMobile) {
      onProvideBackHandler(onBack)
    }
  }, [onBack, onProvideBackHandler, isMobile])

  const { openModal } = useModals()
  const { mutate: updateBrandProfile, isLoading: isUpdatingBrandProfile } = useUpdateBrandProfile({
    id: brandPlan.brand_profile.id,
  })
  const { mutate: updateBrandPlan, isLoading: isUpdatingBrandPlan } = useUpdateBrandPlan({ id: brandPlan.id })
  const { mutate: createBrandPlanPreparationSync, isLoading: isPreparing } = useCreateBrandPlanPreparationSync({
    brandPlanId: brandPlan.id,
  })

  const {
    start: startThree,
    progress: progressThree,
    isRunning: isRunningThree,
    reset: resetThree,
  } = useProgress({
    linearProgress: true,
    immediateComplete: true,
    speed: 17,
  })

  const {
    start: startTwo,
    progress: progressTwo,
    isRunning: isRunningTwo,
    reset: resetTwo,
  } = useProgress({
    linearProgress: true,
    immediateComplete: true,
    speed: 17,
    onDone: startThree,
  })

  const {
    start: startOne,
    progress: progressOne,
    isRunning: isRunningOne,
    reset: resetOne,
  } = useProgress({
    linearProgress: true,
    immediateComplete: true,
    speed: 17,
    onDone: startTwo,
  })

  const handleCampaignModeSubmit = (formValues: FormValues) => {
    const formTactics = formValues.tactics
    const allTactics = [
      ...formTactics,
      ...(isSeoSelected ? [BrandPlanTactic.SEO] : []),
      ...(isEmailSelected ? [BrandPlanTactic.Email] : []),
    ]

    const platformSelections = buildPlatformSelections(
      isSeoSelected,
      isEmailSelected,
      selectedBlogPlatform,
      selectedEmailPlatform,
    )

    const isGmbInTactics = allTactics.includes(BrandPlanTactic.GoogleBusinessProfile)

    const contentPayload =
      formValues.crosspost_frequency === 'always'
        ? {
            crosspost_contents: formValues.crosspost_contents,
            video_crosspost_contents: formValues.video_crosspost_contents,
            instagram_contents: formValues.instagram_contents,
          }
        : {
            ...(allTactics.includes(BrandPlanTactic.Instagram) && {
              instagram_contents: formValues.instagram_contents,
            }),
            ...(allTactics.includes(BrandPlanTactic.Facebook) && { facebook_contents: formValues.facebook_contents }),
            ...(allTactics.includes(BrandPlanTactic.LinkedIn) && { linkedin_contents: formValues.linkedin_contents }),
            ...(allTactics.includes(BrandPlanTactic.Twitter) && { twitter_contents: formValues.twitter_contents }),
            ...(allTactics.includes(BrandPlanTactic.TikTok) && { tiktok_contents: formValues.tiktok_contents }),
            ...(allTactics.includes(BrandPlanTactic.YouTube) && { youtube_contents: formValues.youtube_contents }),
          }

    const paidAdsOnboardingParameters = {
      weeklyAdsBudget: formValues.weekly_ads_budget,
      selectedPlatforms: allTactics.includes(BrandPlanTactic.MetaAds)
        ? [TACTIC_TO_PROVIDER[BrandPlanTactic.MetaAds] as PaidAdsIntegration]
        : [],
    }

    const nextData = {
      tactics: allTactics,
      seoKeywords,
      idealCustomers,
      selectedBlogPlatform,
      selectedEmailPlatform,
      startDate,
      paidAdsOnboardingParameters,
      crosspost_frequency: formValues.crosspost_frequency,
      ...contentPayload,
      ...(isSeoSelected && formValues.seo_contents ? { seo_contents: formValues.seo_contents } : {}),
      ...(isEmailSelected && formValues.email_contents ? { email_contents: formValues.email_contents } : {}),
      ...(isGmbInTactics && formValues.google_my_business_contents
        ? { google_my_business_contents: formValues.google_my_business_contents }
        : {}),
    }

    if (skipBrandPlanUpdate) {
      onNext(nextData)
      return
    }

    updateBrandProfile({
      keywords: seoKeywords,
      ideal_customer_profiles: idealCustomers,
    })

    updateBrandPlan(
      {
        tactics: allTactics,
        strategy: {
          type: BrandPlanStrategyType.Crosspost,
        },
        start_date: startDate,
        week_days: formValues.week_days as any,
        days_before_review: DEFAULT_SCHEDULE_CONFIG.days_before_review,
        daily_frequency: DEFAULT_SCHEDULE_CONFIG.daily_frequency,
        length: DEFAULT_SCHEDULE_CONFIG.length,
        schedule_length: DEFAULT_SCHEDULE_CONFIG.schedule_length,
        crosspost_frequency: formValues.crosspost_frequency,
        ...contentPayload,
        ...(isSeoSelected && formValues.seo_contents ? { seo_contents: formValues.seo_contents } : {}),
        ...(isEmailSelected && formValues.email_contents ? { email_contents: formValues.email_contents } : {}),
        ...(isGmbInTactics && formValues.google_my_business_contents
          ? { google_my_business_contents: formValues.google_my_business_contents }
          : {}),
        ...platformSelections,
      },
      {
        onSuccess: () => {
          onNext(nextData)
        },
      },
    )
  }

  const updateBrandPlanAndProfile = () => {
    updateBrandProfile({
      keywords: seoKeywords,
      ideal_customer_profiles: idealCustomers,
    })

    const platformSelections = buildPlatformSelections(
      isSeoSelected,
      isEmailSelected,
      selectedBlogPlatform,
      selectedEmailPlatform,
    )

    /// Makeshift changes to place backend logic here and support redesign flow. This should be deprecated in the future or changes in BE if we keep this flow
    const weekDays = DEFAULT_SCHEDULE_CONFIG.week_days
    const postsPerDay = 1
    const crosspostPostsPerWeek = Math.min(weekDays.length, 4)
    const shortFormVideosPerWeek = Math.min(weekDays.length, 3)
    const blogAndEmailPostsPerWeek = Math.min(weekDays.length, 2)
    const expectedSocialPosts = postsPerDay * crosspostPostsPerWeek
    const contentPayload: any = {}

    const socialPlatforms = ['instagram', 'facebook', 'linkedin', 'twitter']
    const tacticStrings = tactics.map((t) => t.toLowerCase())
    const hasSocialTactics = socialPlatforms.some((p) => tacticStrings.includes(p))

    if (hasSocialTactics) {
      contentPayload.crosspost_contents = [{ type: 'post', count: expectedSocialPosts }]

      if (tacticStrings.includes('instagram')) {
        contentPayload.instagram_contents = [{ type: 'story', count: 1 }]
      }
    }

    const videoPlatforms = ['tiktok', 'youtube', 'instagram_reel']
    const hasVideoTactics = videoPlatforms.some((p) => tacticStrings.includes(p))
    if (hasVideoTactics) {
      contentPayload.video_crosspost_contents = [{ type: 'post', count: shortFormVideosPerWeek }]
    }

    if (isSeoSelected) {
      contentPayload.seo_contents = [{ type: 'blog_post', count: blogAndEmailPostsPerWeek }]
    }

    if (isEmailSelected) {
      contentPayload.email_contents = [{ type: 'newsletter', count: blogAndEmailPostsPerWeek }]
    }

    if (tacticStrings.includes('google_my_business')) {
      contentPayload.google_my_business_contents = [{ type: 'post', count: blogAndEmailPostsPerWeek }]
    }

    startOne()
    abortControllerRef.current = new AbortController()

    updateBrandPlan(
      {
        tactics,
        start_date: dayjs().add(2, 'day').format('YYYY-MM-DD'),
        ...(DEFAULT_SCHEDULE_CONFIG as any),
        ...platformSelections,
        ...contentPayload,
      },
      {
        onSuccess: () => {
          createBrandPlanPreparationSync(
            { signal: abortControllerRef.current?.signal },
            {
              onSuccess: () => {
                onNext({
                  tactics,
                  seoKeywords,
                  idealCustomers,
                  selectedBlogPlatform,
                  selectedEmailPlatform,
                  paidAdsOnboardingParameters: {
                    weeklyAdsBudget,
                    selectedPlatforms: tactics.includes(BrandPlanTactic.MetaAds)
                      ? [TACTIC_TO_PROVIDER[BrandPlanTactic.MetaAds] as PaidAdsIntegration]
                      : [],
                  },
                })
              },
            },
          )
        },
      },
    )
  }

  const handleBack = () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort()
      abortControllerRef.current = null
    }
    resetOne()
    resetTwo()
    resetThree()
    onBack()
  }

  const { mutate: addExternalIntegrationsToBrandKit, isLoading: isAddingExternalIntegrations } =
    useAddExternalIntegrationsToBrandKit({
      onSuccess: () => {
        updateBrandPlanAndProfile()
      },
    })

  const getInitialTactics = () => {
    // Priority 1: Tactics from external integrations
    const integrationProviders = new Set<ExternalIntegrationEnum>(
      brand_kit?.external_integrations?.map((integration) => integration.provider) || [],
    )
    const tacticsFromIntegrations =
      brand_kit?.external_integrations
        ?.map((integration) => insightChannelsToTactics[integration.provider])
        .filter((tactic): tactic is BrandPlanTactic => tactic !== undefined) || []

    // Priority 2: Tactics from initialInsightChannels that don't have external integrations
    const tacticsFromInsightChannels = (initialInsightChannels as ExternalIntegrationEnum[])
      .filter((channel) => !integrationProviders.has(channel))
      .map((channel) => insightChannelsToTactics[channel])
      .filter((tactic): tactic is BrandPlanTactic => tactic !== undefined)

    // Priority 3: Tactics from initialTactics || brandPlan.tactics
    const tacticsFromSaved = initialTactics || brandPlan.tactics

    // Build savedTactics with max 3, following priority order
    const savedTactics: BrandPlanTactic[] = []
    const addedTactics = new Set<BrandPlanTactic>()

    // Add tactics from integrations (priority 1)
    for (const tactic of tacticsFromIntegrations) {
      if (savedTactics.length < 3 && !addedTactics.has(tactic)) {
        savedTactics.push(tactic)
        addedTactics.add(tactic)
      }
    }

    // Add tactics from insight channels without integrations (priority 2)
    for (const tactic of tacticsFromInsightChannels) {
      if (savedTactics.length < 3 && !addedTactics.has(tactic)) {
        savedTactics.push(tactic)
        addedTactics.add(tactic)
      }
    }

    // Add tactics from saved tactics (priority 3)
    for (const tactic of tacticsFromSaved) {
      if (savedTactics.length < 3 && !addedTactics.has(tactic)) {
        savedTactics.push(tactic)
        addedTactics.add(tactic)
      }
    }

    let social = savedTactics.filter((tactic) => SOCIAL_MEDIA_TACTICS.includes(tactic as SocialTactic))
    let video = savedTactics.filter((tactic) => VIDEO_TACTICS.includes(tactic))
    let seo = savedTactics.includes(BrandPlanTactic.SEO)
    let email = savedTactics.includes(BrandPlanTactic.Email)

    if (isStarterPlan) {
      let count = social.length + video.length + (seo ? 1 : 0) + (email ? 1 : 0)

      if (count > STARTER_PLAN_CHANNEL_LIMIT) {
        social = social.slice(0, STARTER_PLAN_CHANNEL_LIMIT)
        count = social.length

        if (count < STARTER_PLAN_CHANNEL_LIMIT) {
          video = video.slice(0, STARTER_PLAN_CHANNEL_LIMIT - count)
          count += video.length
        } else {
          video = []
        }

        seo = count < STARTER_PLAN_CHANNEL_LIMIT && seo
        if (seo) count++

        email = count < STARTER_PLAN_CHANNEL_LIMIT && email
      }
    }

    return { social, video, seo, email }
  }

  const initialTacticsConfig = getInitialTactics()

  const [socialTactics, setSocialTactics] = useState<BrandPlanTactic[]>(initialTacticsConfig.social)
  const [videoTactics, setVideoTactics] = useState<BrandPlanTactic[]>(initialTacticsConfig.video)
  const [paidAdsTactics, setPaidAdsTactics] = useState<BrandPlanTactic[]>([])
  const [seoKeywords, setSeoKeywords] = useState<string[]>(
    initialSeoKeywords?.length ? initialSeoKeywords : brandPlan.brand_profile.keywords || [],
  )
  const [isSeoSelected, setIsSeoSelected] = useState<boolean>(isCampaignMode ? true : initialTacticsConfig.seo)
  const [isEmailSelected, setIsEmailSelected] = useState<boolean>(isCampaignMode ? true : initialTacticsConfig.email)
  const [idealCustomers] = useState<string[]>(
    initialIdealCustomers?.length ? initialIdealCustomers : brandPlan.brand_profile.ideal_customer_profiles || [],
  )

  const tactics = useMemo(
    () =>
      Array.from(
        new Set([
          ...socialTactics,
          ...videoTactics,
          ...paidAdsTactics,
          ...(isSeoSelected ? [BrandPlanTactic.SEO] : []),
          ...(isEmailSelected ? [BrandPlanTactic.Email] : []),
        ]),
      ),
    [socialTactics, videoTactics, paidAdsTactics, isSeoSelected, isEmailSelected],
  )

  const selectedChannelCount = useMemo(() => {
    return (
      socialTactics.length +
      videoTactics.length +
      paidAdsTactics.length +
      (isSeoSelected ? 1 : 0) +
      (isEmailSelected ? 1 : 0)
    )
  }, [socialTactics, videoTactics, paidAdsTactics, isSeoSelected, isEmailSelected])

  const isAtChannelLimit = isStarterPlan && selectedChannelCount >= STARTER_PLAN_CHANNEL_LIMIT

  const socialChannels: ChannelConfig[] = [
    { tactic: BrandPlanTactic.Instagram, label: 'Instagram', icon: InstagramBrand24 },
    { tactic: BrandPlanTactic.Facebook, label: 'Facebook', icon: FacebookBrand35 },
    { tactic: BrandPlanTactic.LinkedIn, label: 'LinkedIn', icon: LinkedInBrand32 },
    { tactic: BrandPlanTactic.Twitter, label: 'X/Twitter', icon: TwitterBrand },
    ...(googleMyBusinessEnabled
      ? [
          {
            tactic: BrandPlanTactic.GoogleBusinessProfile,
            label: 'Business Profile',
            icon: Google,
            noProviderRequired: true,
            tooltip: 'GBP, formerly Google My Business',
          },
        ]
      : []),
  ]

  const videoChannels: ChannelConfig[] = [
    { tactic: BrandPlanTactic.TikTok, label: 'TikTok', icon: TikTokBrand },
    { tactic: BrandPlanTactic.InstagramReel, label: 'Instagram Reels', icon: InstagramReelsBrand },
    { tactic: BrandPlanTactic.YouTube, label: 'YouTube Shorts', icon: YouTubeBrand },
  ]

  const paidAdsChannels: ChannelConfig[] = [
    { tactic: BrandPlanTactic.MetaAds, label: 'Meta', icon: MetaBrand },
    { tactic: 'google_ads' as BrandPlanTactic, label: 'Google', icon: Google },
  ]

  const shouldOpenSelectAccountsModal = useMemo(() => {
    return (
      tactics?.some((tactic) => {
        const integrationsForTactic = externalIntegrations?.filter(
          (integration) => integration.provider === TACTIC_TO_PROVIDER[tactic],
        )
        return integrationsForTactic?.length && integrationsForTactic?.length > 1
      }) || false
    )
  }, [externalIntegrations, tactics])

  const externalIntegrationIds =
    externalIntegrations
      ?.filter((integration) => tactics.some((tactic) => integration.provider === TACTIC_TO_PROVIDER[tactic]))
      .map((integration) => integration.id) || []

  const handleSubmit = () => {
    if (isCampaignMode) {
      setIsSubmitButtonDisabled(true)
      const submitButton = document.getElementById('campaign-mode-submit-button')
      submitButton?.click()
      return
    }

    if (!brandKitId) {
      updateBrandPlanAndProfile()
      return
    }

    if (shouldOpenSelectAccountsModal) {
      openModal(SelectAccountsModal, {
        externalIntegrations,
        tactics,
        isLoading,
        brandKitId,
        onConfirm: () => {
          updateBrandPlanAndProfile()
        },
      })
    } else {
      if (externalIntegrationIds.length > 0) {
        addExternalIntegrationsToBrandKit({
          id: brandKitId,
          externalIntegrationIds,
        })
      } else {
        updateBrandPlanAndProfile()
      }
    }
  }

  const handleSocialTacticsChange = (tactics: BrandPlanTactic[], isSelected: boolean) => {
    if (isSelected) {
      setSocialTactics((t) => [...t, ...tactics])
    } else {
      setSocialTactics((t) => t.filter((tactic) => !tactics.includes(tactic)))
    }
  }

  const handleVideoTacticsChange = (tactics: BrandPlanTactic[], isSelected: boolean) => {
    if (isSelected) {
      setVideoTactics((t) => [...t, ...tactics])
    } else {
      setVideoTactics((t) => t.filter((tactic) => !tactics.includes(tactic)))
    }
  }

  const handlePaidAdsTacticsChange = (tactics: BrandPlanTactic[], isSelected: boolean) => {
    if (isSelected) {
      setPaidAdsTactics((t) => [...t, ...tactics])
    } else {
      setPaidAdsTactics((t) => t.filter((tactic) => !tactics.includes(tactic)))
    }
  }

  const handleSeoKeywordsChange = (keywords: string[], isSelected: boolean) => {
    setIsSeoSelected(isSelected)
    if (isSelected && seoKeywords.length === 0) {
      setSeoKeywords(keywords)
    }
  }

  useEffect(() => {
    if (isEvergreenMode && !isStarterPlan) {
      setIsEmailSelected(idealCustomers.length > 0)
    }
  }, [idealCustomers, isEvergreenMode, isStarterPlan])

  const isLoading =
    isUpdatingBrandPlan ||
    isUpdatingBrandProfile ||
    (isEvergreenMode && (isPreparing || isRunningOne || isRunningTwo || isRunningThree))

  if (isEvergreenMode && (isPreparing || isRunningOne || isRunningTwo || isRunningThree)) {
    return (
      <>
        <Loading
          showSupportButton={!isMobile}
          backgroundClassName={cx(AutopilotRegistrationAndOnboardingStyles.cloudBackground, Styles.loadingBackground)}
          onCancel={handleBack}
          header="Blaze is creating your first batch of topics"
          description={undefined}
          progresses={[
            {
              title: 'Analyzing ideas',
              isRunning: isRunningOne,
              percentComplete: progressOne,
            },
            { title: 'Generating topics', isRunning: isRunningTwo, percentComplete: progressTwo },
            { title: 'Finishing up', isRunning: isRunningThree, percentComplete: progressThree },
          ]}
        />
      </>
    )
  }

  const getTitle = () => {
    if (isCampaignMode) {
      if (isMobile) {
        return 'Your recommended content plan'
      }
      return 'Pick which channels and content you want to use in your campaigns. '
    }
    if (isStarterPlan) {
      return 'Pick three channels you want to use'
    }
    return 'Tell Blaze where to focus'
  }

  const getDescription = () => {
    if (isCampaignMode && isMobile) {
      return 'Select which channels you want to use in your campaigns. You can change this later.'
    }
    if (isStarterPlan) {
      return 'The Starter plan includes 3 channels. Please select (or deselect) to change channels. You can adjust them anytime later."'
    }
    return 'Select platforms you have business accounts on for your brand. You can change this later.'
  }

  return (
    <div className={isMobile && isCampaignMode ? Styles.mobileWrapper : undefined}>
      <MultiStepStepLayout
        title={getTitle()}
        description={getDescription()}
        scrollContainerClassName={VirtualMarketerOnboardingStyles.scrollContainer}
      >
        <StickyFooterProvider
          footer={
            <StickyFooter>
              <FooterButtons>
                {!isMobile && (
                  <ResponsiveDesign.Desktop>
                    <Button
                      id="brand-plan-tactics-back"
                      variant="tertiary"
                      size="lg"
                      onPress={handleBack}
                      aria-label="Back"
                    >
                      Back
                    </Button>
                  </ResponsiveDesign.Desktop>
                )}
                <Button
                  id="brand-plan-tactics-next"
                  size="lg"
                  onPress={handleSubmit}
                  aria-label="Looks Good"
                  isDisabled={
                    isSubmitButtonDisabled ||
                    isLoading ||
                    isUpdatingBrandProfile ||
                    tactics.length === 0 ||
                    isAddingExternalIntegrations
                  }
                  fullWidth={isMobile}
                >
                  Looks Good
                </Button>
              </FooterButtons>
            </StickyFooter>
          }
        >
          {isCampaignMode ? (
            <CampaignModeForm
              onSubmit={handleCampaignModeSubmit}
              isLoading={isLoading}
              brandPlan={brandPlan}
              isSeoSelected={isSeoSelected}
              isEmailSelected={isEmailSelected}
              selectedBlogPlatform={selectedBlogPlatform}
              selectedEmailPlatform={selectedEmailPlatform}
              onSeoSelectionChange={setIsSeoSelected}
              onEmailSelectionChange={setIsEmailSelected}
              onBlogPlatformChange={setSelectedBlogPlatform}
              onEmailPlatformChange={setSelectedEmailPlatform}
              wixEnabled={wixEnabled}
              startDate={startDate}
              onStartDateChange={setStartDate}
              shopifyEnabled={shopifyEnabled}
              googleMyBusinessEnabled={googleMyBusinessEnabled}
            />
          ) : (
            <div className={Styles.brandPlanTactics}>
              <div className={Styles.evergreenGrid}>
                <div className={Styles.evergreenColumn}>
                  <EvergreenChannelSection
                    icon={HighDetailedSocial}
                    title="Social Media"
                    subtitle="Build your audience"
                    channels={socialChannels}
                    selectedTactics={socialTactics}
                    onTacticsChange={handleSocialTacticsChange}
                    isAtChannelLimit={isAtChannelLimit}
                    disabledTooltip={STARTER_PLAN_DISABLED_TOOLTIP}
                  />

                  <EvergreenChannelSection
                    icon={VideoHighDetail}
                    title="Video"
                    subtitle="Show your personality"
                    channels={videoChannels}
                    selectedTactics={videoTactics}
                    onTacticsChange={handleVideoTacticsChange}
                    isAtChannelLimit={isAtChannelLimit}
                    disabledTooltip={STARTER_PLAN_DISABLED_TOOLTIP}
                  />

                  {isStarterPlan && isAdsOnboardingEnabled && (
                    <EvergreenChannelSection
                      icon={PaidAds}
                      title="Paid Ads"
                      subtitle="Reach new customers"
                      channels={paidAdsChannels}
                      selectedTactics={paidAdsTactics}
                      onTacticsChange={handlePaidAdsTacticsChange}
                      isAtChannelLimit={isAtChannelLimit}
                      disabledTooltip={STARTER_PLAN_DISABLED_TOOLTIP}
                      rightContent={
                        <WeeklyBudgetInput
                          value={weeklyAdsBudget}
                          onChange={setWeeklyAdsBudget}
                          disabled={paidAdsTactics.length === 0}
                        />
                      }
                    />
                  )}
                </div>

                <div className={Styles.evergreenColumn}>
                  <EvergreenPlatformSection
                    type="blog"
                    isSelected={isSeoSelected}
                    selectedPlatform={selectedBlogPlatform}
                    onSelectionChange={(isSelected) =>
                      handleSeoKeywordsChange(brandPlan.brand_profile.keywords, isSelected)
                    }
                    onPlatformChange={(platform) => setSelectedBlogPlatform(platform as SelectedBlogPlatform)}
                    wixEnabled={wixEnabled}
                    shopifyEnabled={shopifyEnabled}
                    isDisabled={isAtChannelLimit}
                    disabledTooltip={STARTER_PLAN_DISABLED_TOOLTIP}
                  />

                  <EvergreenPlatformSection
                    type="email"
                    isSelected={isEmailSelected}
                    selectedPlatform={selectedEmailPlatform}
                    onSelectionChange={setIsEmailSelected}
                    onPlatformChange={(platform) => setSelectedEmailPlatform(platform as SelectedEmailPlatform)}
                    isDisabled={isAtChannelLimit}
                    disabledTooltip={STARTER_PLAN_DISABLED_TOOLTIP}
                  />
                </div>
              </div>
            </div>
          )}
        </StickyFooterProvider>
      </MultiStepStepLayout>
    </div>
  )
}

const BrandPlanTacticsContainer = ({
  id,
  onBack,
  onNext,
  externalIntegrations,
  brandKitId,
  tactics,
  seoKeywords,
  idealCustomers,
  mode,
  skipBrandPlanUpdate,
  initialInsightChannels,
  onProvideBackHandler,
}: BrandPlanTacticsContainerProps) => {
  const { data: brandPlan } = useBrandPlan(id)

  if (!brandPlan) {
    return null
  }

  return (
    <BrandPlanTactics
      brandPlan={brandPlan}
      onBack={onBack}
      onNext={onNext}
      externalIntegrations={externalIntegrations}
      brandKitId={brandKitId}
      tactics={tactics}
      seoKeywords={seoKeywords}
      idealCustomers={idealCustomers}
      mode={mode}
      skipBrandPlanUpdate={skipBrandPlanUpdate}
      initialInsightChannels={initialInsightChannels}
      onProvideBackHandler={onProvideBackHandler}
    />
  )
}

export { BrandPlanTacticsContainer as BrandPlanTactics }
